import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { Toaster } from "@/components/ui/toaster";
import { initSentry } from "@/lib/sentry";
import { initPostHog } from "@/lib/posthog";

// Initialize Sentry
initSentry();

// Initialize PostHog
initPostHog();

// SECURITY: Import security testing for development validation
import "@/lib/securityTest";

// Render the app
createRoot(document.getElementById("root")!).render(
  <>
    <App />
    <Toaster />
  </>
);
